import _ from 'lodash'
import { mapKeys } from '@util/generalUtil'

const userRolesEnum = {
  operator: { id: 10, level: 20, label: 'Operador' },
  manager: { id: 15, level: 30, label: 'Gestor' },
  beneficiary: { id: 5, level: 10, label: 'Beneficiario' },
}

export const UserRoles = Object.freeze({
  ...userRolesEnum,
  ...mapKeys(userRolesEnum, (value) => value.id),
  list: _.map(_.values(userRolesEnum), ({ id, ...rest }) => ({ value: id, ...rest })),
})
